import AuthorizeConsent from 'auth/oauth/AuthorizeConsent';
import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';
import {renderReactComponent} from 'util/RootReactRender';

export const OAuthRoutes: RouteBundle = {
  domain: 'oauth',
  routes: [{urlPattern: 'oauth/authorize', handler: authorize}],
};

function authorize(): void {
  DatadogUtil.startRUMView('oauth_authorize');
  renderReactComponent(AuthorizeConsent);
}
